import Box from "@material-ui/core/Box";
import { purple } from "@material-ui/core/colors";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import DateRangeIcon from "@material-ui/icons/DateRange";
import moment from "moment";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useSelector } from "react-redux";
import SelectionCombo from "./containers/SelectionCombo";

const PurpleSwitch = withStyles({
	switchBase: {
		color: purple[300],
		"&$checked": {
			color: purple[500],
		},
		"&$checked + $track": {
			backgroundColor: purple[500],
		},
	},
	checked: {},
	track: {},
})(Switch);

const IOSSwitch = withStyles((theme) => ({
	root: {
		width: 42,
		height: 26,
		padding: 0,
		margin: theme.spacing(1),
	},
	switchBase: {
		padding: 1,
		"&$checked": {
			transform: "translateX(16px)",
			color: theme.palette.common.white,
			"& + $track": {
				backgroundColor: "#52d869",
				opacity: 1,
				border: "none",
			},
		},
		"&$focusVisible $thumb": {
			color: "#52d869",
			border: "6px solid #fff",
		},
	},
	thumb: {
		width: 24,
		height: 24,
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(["background-color", "border"]),
	},
	checked: {},
	focusVisible: {},
}))(({ classes, ...props }) => {
	return (
		<Switch
			focusVisibleClassName={classes.focusVisible}
			disableRipple
			classes={{
				root: classes.root,
				switchBase: classes.switchBase,
				thumb: classes.thumb,
				track: classes.track,
				checked: classes.checked,
			}}
			{...props}
		/>
	);
});

const AntSwitch = withStyles((theme) => ({
	root: {
		width: 28,
		height: 16,
		padding: 0,
		display: "flex",
	},
	switchBase: {
		padding: 2,
		color: theme.palette.grey[500],
		"&$checked": {
			transform: "translateX(12px)",
			color: theme.palette.common.white,
			"& + $track": {
				opacity: 1,
				backgroundColor: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
	},
	thumb: {
		width: 12,
		height: 12,
		boxShadow: "none",
	},
	track: {
		border: `1px solid ${theme.palette.grey[500]}`,
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: theme.palette.common.white,
	},
	checked: {},
}))(Switch);

const EditStatusForm = forwardRef((props, ref) => {
	const refStatusReason = useRef(null);
	const refStatusActing = useRef(null);

	useImperativeHandle(ref, () => {
		return {
			handleShowStatusError: handleShowStatusError,
		};
	});

	const getState = useSelector((state) => state);
	let allUser = getState.auth.user.allUser.filter((x) => x.status === 1);
	let settings = getState.auth.user.settings;
	let usernameInfo = allUser.find(
		(y) => y._id === getState.auth.user.usernameId
	);

	let initialStatestatus = {
		checkedA: true,
		checkedB: true,
		checkedC: 
		props.statusMoreInfo? props.statusMoreInfo.status
				? props.statusMoreInfo.status === 1
					? true
					: false
				: false
			: 
		
		usernameInfo
			? usernameInfo.status
				? usernameInfo.status === 1
					? true
					: false
				: false
			: false,
	};
	const [state, setState] = React.useState(initialStatestatus);
	const [selectionRange, setSelectionRange] = React.useState({
		startDate: new Date(),
		endDate: new Date(),
		key: "selection",
	});
	const [showDatepicker, setShowDatePicker] = React.useState(false);
	let reasonError;
	console.log("EditStatusForm props.error=", props.error);
	console.log("EditStatusForm props=",props)

	try {
		reasonError = props.error.reason;
	} catch (e) {}

	console.log("EditStatusForm setting=", settings[0].userStatus);

	const [users, setUser] = React.useState(
		allUser
			.map((x) => ({
				title: x.username,
				id: x._id,
			}))
			.filter((x) => x.title !== null)
	);
	const [reasons, setReasons] = React.useState(
		settings[0].userStatus
			.map((x) => ({
				title: x.description,
				action: x.action,
				id: x.id,
			}))
			.filter((x) => x.title !== null && x.action === "OFF" && x.id > 0)
	);
	const [userActingValue, setUserActingValue] = React.useState("");
	const [reasonActingValue, setReasonActingValue] = React.useState("");
	const setReasonActingValueFx = (value) => {
		console.log("setReasonActingValueFx reached value=", value);
		setReasonActingValue(value);
	};
	const setUserActingValueFx = (value) => {
		console.log("setUserActingValueFx reached value=", value);
		setUserActingValue(value);
	};

	const handleShowStatusError = (error) => {
		try {
			refStatusReason.current.showError(error.reason);
		} catch (e) {}
		try {
			refStatusActing.current.showError(error.userActing);
		} catch (e) {}
	};

	React.useEffect(() => {
		if(props.setStatus)
		{
		props.setStatus({
			action: state.checkedC,
			statusId: reasonActingValue.id,
			status: reasonActingValue.id,
			reason: reasonActingValue.title,
			fromDate: new Date(selectionRange.startDate).setHours(0, 0, 0, 0),
			toDate: new Date(selectionRange.endDate).setHours(23, 59, 59, 0),
			userActing: userActingValue.title,
		});
	}
	}, [state, reasonActingValue, selectionRange, userActingValue]);

	console.log(
		"allUser =",
		allUser
			.map((x) => ({
				title: x.username,

				id: x._id,
			}))
			.filter((x) => x.title !== null)
	);

	const handleSelect = (ranges) => {
		console.log("ranges=", ranges);

		// {
		//   selection: {
		//     startDate: [native Date Object],
		//     endDate: [native Date Object],
		//   }
		// }
		try {
			setSelectionRange({
				startDate: new Date(ranges.selection.startDate),
				endDate: new Date(ranges.selection.endDate),
				key: "selection",
			});
		} catch (e) {
			console.error("EditStatusForm setSelectionRange error=", e);
		}
	};

	//set new status
	//props.setStatus

	const handleChange = (event) => {
		setState({
			...state,
			[event.target.name]: event.target.checked,
		});
	};

	const closeDatePicker = () => {
		setShowDatePicker(false);
	};

	React.useEffect(() => {
		console.log("switch state =", state);
		if (state.checkedC) {
		} else {
		}
	}, [state]);

	return (
		<FormGroup>
			<Typography
				component="div"
				style={{
					width: 570,
					height: 800,
				}}
			>
				<Grid component="label" container alignItems="center" spacing={1}>
					<Grid item>Off</Grid>
					<Grid item>
						<AntSwitch
							checked={state.checkedC}
							onChange={handleChange}
							name="checkedC"
						/>
					</Grid>
					<Grid item>On</Grid>
				</Grid>
				{!state.checkedC ? (
					<div className="input-group mb-3">
						<input
							type="text"
							className="form-control"
							placeholder={
								moment(selectionRange.startDate).format("Do,MMM yyyy") +
								"  - " +
								moment(selectionRange.endDate).format("Do,MMM yyyy")
							}
							onClick={() => setShowDatePicker(!showDatepicker)}
							style={{ width: "200" }}
						/>
						<div className="input-group-append">
							<span className="input-group-text">
								<DateRangeIcon />

								{showDatepicker && (
									<IconButton
										color="primary"
										aria-label="Accept"
										component="span"
										onClick={() => setShowDatePicker(!showDatepicker)}
									>
										<CheckBoxIcon />
									</IconButton>
								)}
							</span>
						</div>
					</div>
				) : (
					""
				)}
				{showDatepicker && !state.checkedC ? (
					<DateRangePicker
						minDate={new Date()}
						ranges={[selectionRange]}
						onChange={handleSelect}
					/>
				) : (
					""
				)}
				{!showDatepicker && users.length > 0 && !state.checkedC ? (
					<>
						<Box m={1}>
							<SelectionCombo
								ref={refStatusReason}
								title="Select a Reason"
								options={reasons}
								error={reasonError}
								setUserTitleValue={(value) => {
									console.log(
										"setUserTitleValue Select a Reason value=",
										value
									);
									try {
										if (value.title !== null) {
											setReasonActingValueFx(value);
										}
									} catch (e) {
										setReasonActingValueFx("");
									}
								}}
							/>
						</Box>

						<Box m={1}>
							<SelectionCombo
								ref={refStatusActing}
								title="Select who will be Acting fo you"
								options={users}
								setUserTitleValue={(value) => {
									console.log(
										"setUserTitleValue Select who will be Acting fo you value=",
										value
									);
									try {
										if (value.title !== null) {
											setUserActingValueFx(value);
										}
									} catch (e) {
										setUserActingValueFx("");
									}
								}}
							/>
						</Box>
					</>
				) : (
					""
				)}
			</Typography>
		</FormGroup>
	);
});
export default EditStatusForm;
